import { render, staticRenderFns } from "./EditHeader.vue?vue&type=template&id=3c8e851f&"
import script from "./EditHeader.vue?vue&type=script&lang=js&"
export * from "./EditHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports